import React from 'react';
import ContentPanel from '../../components/ContentPanel/ContentPanel';
import Skeleton from '../../components/Skeleton/Skeleton';
import ContentAccordion from '../../components/ContentAccordion/ContentAccordion';
import ToolsWidget from '../../components/ToolsWidget/ToolsWidget';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import store from "../../store";
import {Helmet} from "react-helmet";

const humanRemains = () => {
  return (
    <div className="wrapper">
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Ship" ? row.sections.map((section) => {
                        return section.title === "Products" ? section.subsections.map((subsection) => {
                                    return subsection.title === "Southwest Support" ? <meta name="description" content={subsection.content['seo-description']}/> : null
                                })
                                : null
                    }) : null
                }) : null
            }
        </Helmet>
      <Breadcrumbs pageTitle="Human Remains"/>
      <ContentPanel
        skeleton={<Skeleton type="MAIN_PANEL" />}
        errorTemplate={<Skeleton type="MAIN_PANEL_ERROR" />}
        templateUrl="./content/learn/page-components/text-block/human-remains-heading.html"
      />
      <ContentAccordion jsonDataUrl="./content/learn/page-components/accordion/human-remains.json" />
      <div className="mvl pbm">
        <ToolsWidget />
      </div>
    </div>
  );
};

export default humanRemains;



// WEBPACK FOOTER //
// ./src/pages/learn/HumanRemains.js